export default __webpack_public_path__ + "static/bitcoin-hero-62d6695b3ab0a769a6f5f2d6679874ea.svg";